const wgResourceType = {
    wgUnknown: -1,
    wgBuffer: 0,
    wgVertexBuffer: 1,
    wgElementsVertexBuffer: 2,
    wgUniformBuffer: 3,
    wgStorageBuffer: 4,
    wgShader: 5,
    wgMaterial: 6,
    wgTexture: 7,
    wgMesh: 8,
    wgFbo: 9,
    wgPrimitiveRender: 10,
    wgUiRender: 11,
    wgScene: 12,
    wgMeshBuilder: 13,
};

class wgResource {
    constructor(name, context, type) {
        this.context_ = context;
        this.name_ = name;
        this.type_ = type === undefined ? wgResourceType.wgUnknown : type; // read-only
    }

    getName() {
        return this.name_;
    }
    getContext() {
        return this.context_;
    }
    getType() {
        return this.type_;
    }
}

export { wgResource, wgResourceType };
